<template>
  <div class="exportador-dashboard">

    <!-- Dialogs -->
    <v-dialog v-model="dialogErro.status" persistent max-width="500">
      <CardDialog :dialog="dialogErro" />
    </v-dialog>

    <v-dialog v-model="carregando" persistent max-width="430">
      <v-card class="loading-dialog" flat>
        <div class="loading-dialog-header">
          <v-progress-circular indeterminate color="white" size="24" width="3" class="mr-3" />
          <span>Processando arquivo</span>
        </div>
        <v-card-text class="pa-5 pt-4">
          <div class="loading-dialog-text">Aguarde enquanto geramos o relatório de pagamento...</div>
          <v-progress-linear indeterminate color="#023449" rounded height="3" class="mt-4" />
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Snackbars -->
    <v-snackbar v-model="snackbar.status" :timeout="snackbar.timeout" color="warning" bottom>
      <div class="d-flex align-center">
        <v-icon left small>mdi-alert-circle</v-icon>
        <span>Nenhum arquivo gerado para o filtro informado.</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.status = false" color="white">Fechar</v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarSucesso.status" :timeout="snackbarSucesso.timeout" color="success" bottom>
      <div class="d-flex align-center">
        <v-icon left small>mdi-check-circle</v-icon>
        <span>{{ snackbarSucesso.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarSucesso.status = false" color="white">Fechar</v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="snackbarErro.status" :timeout="snackbarErro.timeout" color="error" bottom>
      <div class="d-flex align-center">
        <v-icon left small>mdi-alert-circle</v-icon>
        <span>{{ snackbarErro.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbarErro.status = false" color="white">Fechar</v-btn>
      </template>
    </v-snackbar>

    <!-- Filtros -->
    <ExportadorFiltros
        v-model="busca"
        :filiais-filtro="filiaisFiltro"
        :tipos-comissao="tiposComissao"
        :loading="carregando"
        @gerar="gerarArquivo"
        @limpar="resetarFiltros"
    />

    <!-- Loading -->
    <div v-if="carregando && !temDados" class="loading-state">
      <v-progress-circular indeterminate color="#023449" size="64" />
      <p class="mt-4 loading-text">Carregando dados...</p>
    </div>

    <!-- Estado vazio -->
    <div v-else-if="!carregando && !temDados" class="no-data-message">
      <v-icon size="64" color="#cbd5e1">mdi-folder-download-outline</v-icon>
      <h3>Nenhum dado para exibir</h3>
      <p>Selecione as filiais, tipos de comissão e o mês, então clique em <strong>Gerar</strong></p>
      <div class="no-data-hint">
        <v-icon small color="#023449" class="mr-1">mdi-information-outline</v-icon>
        <span>Os vendedores precisam ter metas cadastradas para serem exportados.</span>
      </div>
    </div>

    <!-- Tabela de resultados -->
    <ExportadorTabela
        v-else-if="temDados"
        :dados="dados"
        :convenios="convenios"
        :dtmes="busca.dtmes"
        :tipos-comissao-selecionados="tiposComissaoConfirmados"
        :arquivo-base64="arquivoBase64"
        :ultima-chamada="ultimaChamada"
        :ultima-atualizacao-salario="ultimaAtualizacaoSalario"
        @export-success="handleExportSuccess"
        @export-error="handleExportError"
    />

  </div>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import mixinFilial from "../../../util/mixinFilial";
import CardDialog from "../../Widgets/CardDialog.vue";
import ExportadorFiltros from "./Widgets/ExportadorFiltros.vue";
import ExportadorTabela from "./Widgets/ExportadorTabela.vue";

export default {
  name: "DepartamentoPessoalExportadorSenior",
  mixins: [mixinFilial],
  components: { CardDialog, ExportadorFiltros, ExportadorTabela },

  data: () => ({
    carregando:      false,
    snackbar:        { status: false, timeout: 4000 },
    snackbarSucesso: { status: false, timeout: 3000, message: '' },
    snackbarErro:    { status: false, timeout: 4000, message: '' },
    dialogErro:      { status: false, title: "", msg: "", icon: "", iconColor: "" },
    dados:     [],
    convenios: [],
    tiposComissaoConfirmados: [],
    arquivoBase64: null,
    ultimaChamada: null,
    ultimaAtualizacaoSalario: null,
    busca: {
      dtmes:         `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}`,
      idfiliais:     [],
      tiposComissao: [
        'comissao_vendedores',
        'bonificacao_vendedores',
        'convenios',
        'bonificacao_motoristas'
      ],
    },
    tiposComissao: [
      { valor: 'comissao_vendedores',    texto: 'Comissão de Vendedores', descricao: 'Comissão baseada em vendas realizadas',   icone: 'mdi-account-cash' },
      { valor: 'bonificacao_vendedores', texto: 'Bonificação Vendedores', descricao: 'Bonificações extras para vendedores',      icone: 'mdi-gift'         },
      { valor: 'convenios',              texto: 'Convênios',              descricao: 'Descontos de convênios em folha',          icone: 'mdi-handshake'    },
      { valor: 'bonificacao_motoristas', texto: 'Bonificação Motoristas', descricao: 'Bonificações para motoristas e ajudantes', icone: 'mdi-truck-fast'   },
    ],
  }),

  computed: {
    ...mapState(["backendUrl"]),
    filiaisFiltro() {
      return this.filiais.lista
          ? this.filiais.lista.filter(v => ![4, 13, 22, 28, 32, 34, 37, 42, 44].includes(v.idfilial))
          : [];
    },
    temDados() {
      return this.dados.length > 0 || this.convenios.length > 0;
    },
  },

  methods: {
    resetarFiltros() {
      this.busca.idfiliais          = [];
      this.busca.tiposComissao      = [];
      this.dados                    = [];
      this.convenios                = [];
      this.tiposComissaoConfirmados = [];
      this.arquivoBase64            = null;
      this.ultimaChamada            = null;
      this.ultimaAtualizacaoSalario = null;
    },

    gerarArquivo() {
      if (!this.busca.tiposComissao.length) {
        this.dialogErro = { status: true, title: "Atenção", msg: "Selecione ao menos um tipo de comissão.", icon: "mdi-alert-circle-outline", iconColor: "orange" };
        return;
      }
      if (!this.busca.idfiliais.length) {
        this.dialogErro = { status: true, title: "Atenção", msg: "Selecione ao menos uma filial.", icon: "mdi-alert-circle-outline", iconColor: "orange" };
        return;
      }

      this.dados      = [];
      this.convenios  = [];
      this.carregando = true;

      axios.post(`${this.backendUrl}dp/exportar-arquivo`, {
        ano:           this.busca.dtmes.split("-")[0],
        mes:           this.busca.dtmes.split("-")[1],
        idfilial:      this.busca.idfiliais.join(","),
        tiposComissao: this.busca.tiposComissao,
        responseType:  "blob",
      })
          .then((res) => {
            this.carregando = false;
            const data = res.data;

            if (JSON.stringify(data) === "{}") {
              this.snackbar.status = true;
              return;
            }

            this.dados                    = data.valores                     || [];
            this.convenios                = data.convenios                   || [];
            this.tiposComissaoConfirmados = [...this.busca.tiposComissao];
            this.arquivoBase64            = data.arquivo                     || null;
            this.ultimaChamada            = new Date();
            this.ultimaAtualizacaoSalario = data.ultimaatualizacaosalario    || null;

            if (!this.dados.length && !this.convenios.length) {
              this.snackbar.status = true;
            }
          })
          .catch((e) => {
            this.carregando = false;
            this.dialogErro = {
              status: true, title: "Erro ao processar",
              msg: e.response?.data?.message || "Ocorreu um erro ao gerar o arquivo.",
              icon: "mdi-alert-circle-outline", iconColor: "red",
            };
          });
    },

    handleExportSuccess(msg) { this.snackbarSucesso.message = msg; this.snackbarSucesso.status = true; },
    handleExportError(msg)   { this.snackbarErro.message   = msg; this.snackbarErro.status   = true; },
  },
};
</script>

<style scoped>
.exportador-dashboard {
  font-family: 'Inter', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}

.loading-state {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  min-height: 400px; background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0;
}

.loading-text { color: #64748b; font-size: 0.875rem; margin: 0; }

.no-data-message {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  min-height: 400px; gap: 12px; padding: 40px;
  background: #ffffff; border-radius: 12px; border: 1px solid #e2e8f0;
}

.no-data-message h3 { margin: 0; color: #023449; font-size: 1.25rem; font-weight: 700; }
.no-data-message p  { color: #64748b; font-size: 0.875rem; margin: 0; text-align: center; }

.no-data-hint {
  display: inline-flex; align-items: center;
  background-color: #f0f9ff; border: 1px solid rgba(2, 52, 73, 0.12);
  border-radius: 8px; padding: 8px 14px;
  font-size: 0.813rem; color: #475569; margin-top: 4px;
}

.loading-dialog { border-radius: 12px; overflow: hidden; }

.loading-dialog-header {
  display: flex; align-items: center;
  background: linear-gradient(135deg, #023449 0%, #0369a1 100%);
  color: #ffffff; padding: 16px 20px;
  font-size: 0.938rem; font-weight: 600;
}

.loading-dialog-text { font-size: 0.875rem; color: #64748b; line-height: 1.5; }

@media (max-width: 599px) {
  .no-data-message { min-height: 300px; padding: 24px 16px; }
  .loading-state   { min-height: 300px; }
}
</style>